/**
 * Z-Index hierarchy for the application
 *
 * Ranges:
 * - 1-49: Base UI elements
 * - 50-99: Navigation and dropdowns
 * - 100-499: Overlays and dialogs
 * - 500-899: Toasts and notifications
 * - 1000-1499: Modals
 * - 1500+: Critical overlays (tooltips, popovers)
 */

export const Z_INDEX = {
  // Base elements
  base: 1,
  raised: 10,

  // Navigation
  navbar: 50,
  dropdown: 60,
  sidebar: 70,

  // Overlays
  drawer: 100,
  sheet: 200,
  dialog: 400,

  // Notifications
  toast: 500,
  snackbar: 600,

  // Modals
  modal: 1000,
  modalOverlay: 999,

  // Critical
  popover: 1500,
  tooltip: 2000,
  loading: 2500,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
export type ZIndexValue = (typeof Z_INDEX)[ZIndexKey];

/**
 * Get z-index value by key
 * @example getZIndex('toast') // 500
 */
export function getZIndex(key: ZIndexKey): ZIndexValue {
  return Z_INDEX[key];
}

/**
 * Compare two z-index values
 * @returns true if a is above b
 */
export function isAbove(a: ZIndexKey, b: ZIndexKey): boolean {
  return Z_INDEX[a] > Z_INDEX[b];
}
